import noop from 'lodash/noop'
import Typography from '@mui/material/Typography'
import {
    useTheme,
} from '@mui/material/styles'

import DateRangeSelector from 'app/shared-components/DateRangeSelector'
import TemperatureChart from 'app/shared-components/TemperatureChart'
import Card from 'app/shared-components/Card'
import getChartOptions from 'app/utils/getChartOptions'
import useLabel from 'app/hooks/useLabel'

import useStyles from './ContainerTemperatureChart.style'

const EMPTY_OBJECT = {}

type Props = {
    timeRange: {
        from: Date,
        to: Date,
    },
    setRange?: (value: any) => void,
    data?: {
        sensorData?: { t: string, d: any[] }[],
        sensorLabels?: any[],
    },
    isDateRange: boolean,
    setDateRange: (value: any) => void,
    onFullScreen: (e: any) => void,
}

const ContainerTemperatureChart = ({
    timeRange,
    setRange = noop,
    data = EMPTY_OBJECT,
    isDateRange,
    setDateRange,
    onFullScreen,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        sensorData,
        sensorLabels,
    } = data
    const theme = useTheme()

    const {
        classes,
    } = useStyles()

    return (
        <div className={classes.wrapper}>
            <div className={classes.chartContainer}>
                <Card className={classes.chartContainer}>
                    <Typography variant="h3">
                        {l('TEMPERATURE_IN_C_UTC_TIME')}
                    </Typography>
                    <DateRangeSelector
                        value={timeRange}
                        onChange={setRange}
                        setDateRange={setDateRange}
                        showTimeRange
                        mini
                    />
                    <TemperatureChart
                        onFullScreen={onFullScreen}
                        sensorData={sensorData}
                        sensorLabels={sensorLabels}
                        isDateRange={isDateRange}
                        userOptions={getChartOptions(theme, sensorLabels)}
                    />
                </Card>
            </div>
        </div>
    )
}

export default ContainerTemperatureChart
